import React, { useCallback } from 'react';
import * as Yup from 'yup';
import GenericModalForm from '../../components/GenericModalForm';
import GenericTextArea from '../../components/GenericTextArea';
import GenericTextInput from '../../components/GenericTextInput';
import { ModalRef } from '../../hooks/useModalRef';
import styled from 'styled-components';
import GenericModal from '../../components/GenericModal';

import { FormikHelpers } from 'formik';
import { Quiz } from '../../models/Quiz';
import useQuiz from '../../services/swr/useQuiz';
import { stripEmptyFields } from '../../utils/objects';

interface ComponentProps {
  quizInfo: Quiz;
}

const EditQuizModal = React.forwardRef(({ quizInfo }: ComponentProps, ref) => {
  const { editQuiz } = useQuiz();

  const onSubmit = useCallback(
    async (
      values: Record<string, unknown>,
      helpers: FormikHelpers<Record<string, unknown>>,
    ) => {
      const quizModel = {
        ...stripEmptyFields(values),
      };

      await editQuiz(quizInfo.id, quizModel);

      const { setSubmitting, resetForm } = helpers;

      setSubmitting(false);
      resetForm();

      (ref as ModalRef).current?.closeModal();
    },
    [quizInfo.id, ref],
  );

  const closeModal = useCallback(
    () => (ref as ModalRef).current?.closeModal(),
    [ref],
  );

  return (
    <ModalContainer ref={ref}>
      <GenericModalForm
        initialValues={{}}
        validationSchema={Yup.object().shape({
          title: Yup.string().optional(),
          tags: Yup.string().optional(),
          description: Yup.string().optional(),
        })}
        submitButtonType="edit"
        onSubmit={onSubmit}
        onCancel={closeModal}
      >
        <GenericTextInput
          name="title"
          label="Título do Quiz"
          type="text"
          placeholder={quizInfo.title}
        />
        <GenericTextArea
          name="description"
          label="Descrição do Quiz"
          placeholder={quizInfo.description || ''}
        />

        <GenericTextInput
          name="tags"
          label="Tags"
          type="text"
          placeholder={quizInfo.tags || ''}
        />
      </GenericModalForm>
    </ModalContainer>
  );
});

export const ModalContainer = styled(GenericModal)`
  width: 80%;
  max-width: 600px;
`;

EditQuizModal.displayName = 'EditQuizModal';

export default EditQuizModal;
